/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
// import { Modal, Box } from '@material-ui/core';
import { Modal, Box } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import styles from './SuccessModal.module.css';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';

const SuccessModal = ({ handleClose, open, title, render_title }) => (
	// console.log("title = ",title, title[0]),
	// console.log("title = ", String(title[0]).charAt(0).toUpperCase() , String(title).slice(1)),
	<Modal open={open} onClose={handleClose}>
		<div className={styles.container}>
			<div className={clsx(styles.title, "largeFont")}>
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					<span style={{ display: "flex" }}>
						{' '}
						<ThumbUpIcon className={styles.block} fontSize="1rem" />
					</span>
					<span className={styles.txt}>Success</span>
				</div>
				<CloseIcon className={styles.crossBlock} fontSize="1rem" onClick={handleClose} />
			</div>

			<Box bgcolor="#dadada3d" height="auto" margin="15px" padding="20px 0 0 20px">
				<p className={clsx(styles.warningText, "largeFont")}>
					{title?.toLowerCase()}
					{render_title? render_title : null}
				</p>
			</Box>
		</div>
	</Modal>
);

SuccessModal.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default SuccessModal;
